import type { App } from 'vue'
import libs from '@/libs/index'

export default {
  install(app: App<Element>) {
    app.use(libs)
  },
}
